<div *ngIf="pagelet?.hasParam('HTML')" [ishServerHtml]="pagelet.stringParam('HTML')"></div>
